import { memo } from 'react'
import type { Language } from '../../../hooks/language/use-translate'
import { useTranslate } from '../../../hooks/language/use-translate'
import { useGetAppSetting } from '../../../hooks/queries/app/use-get-app-setting'
import { formatDecimalPlaces } from '../../../helpers/functions/format-decimal-places'
import closeSvg from '../modal-games/components/images/close.svg'

interface Props {
  onClose: () => void
}

// Regras do Gold Miner. O modal nunca teve conteúdo (só o título, desde o
// primeiro commit no audio-webview-main). O texto segue o que o servidor faz:
// preço de apps_settings_games, prêmio = GIFT no pacote (users_gifts_packages),
// jogada conta no Jogo Responsável (recordGamePlay).
export const ModalRules = memo(({ onClose }: Props) => {
  const { translate } = useTranslate()
  const title = translate('modal-game-gold-miner-rules' as Language)
  const { appSetting } = useGetAppSetting()
  const valueBet = appSetting?.gameGoldMinerValueBet || 0
  const price = valueBet ? formatDecimalPlaces(valueBet) : '—'

  const rules = [
    {
      t: 'Como jogar',
      d: `Toque em 1x, 10x, 50x ou 100x. Cada mineração custa ${price} moedas, e o total aparece no botão antes de você tocar.`,
    },
    {
      t: 'O que você ganha',
      d: 'Cada mineração sempre libera 1 presente. Os presentes possíveis e o valor de cada um estão na placa "Prêmios".',
    },
    {
      t: 'Para onde vai o prêmio',
      d: 'Os presentes vão para a aba Pacote, no painel de presentes da live. De lá você envia para quem quiser, sem gastar moedas de novo.',
    },
    {
      t: 'Meus ganhos',
      d: 'Na placa "Ganhos" fica tudo o que você minerou, separado por dia, com a quantidade e o horário.',
    },
    {
      t: 'Resultado',
      d: 'O sorteio é feito pelo servidor na hora da jogada. Fechar o jogo ou a internet cair no meio não altera o prêmio: ele já está no seu Pacote.',
    },
    {
      t: 'Jogo Responsável',
      d: 'Para jogar é preciso aceitar o termo de Jogo Responsável e definir um limite diário de perda no menu de jogos. Atingido o limite, os jogos voltam no dia seguinte.',
    },
  ]

  return (
    <div className="absolute inset-0 z-30 flex flex-col overflow-hidden rounded-t-2xl bg-gradient-to-b from-[#241706] to-black">
      <div className="relative flex shrink-0 items-center justify-center px-4 pt-4 pb-3">
        <h2 className="text-lg font-extrabold tracking-wide text-amber-300 drop-shadow">
          {title}
        </h2>
        <button
          type="button"
          onClick={onClose}
          className="absolute top-1/2 right-3 -translate-y-1/2"
        >
          <img src={closeSvg} alt="Fechar" className="h-4 w-4" />
        </button>
      </div>
      <ol className="flex-1 space-y-2 overflow-y-auto px-4 pb-6">
        {rules.map((r, i) => (
          <li
            key={r.t}
            className="flex gap-3 rounded-xl border border-amber-400/10 bg-white/5 px-3 py-2.5"
          >
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-amber-400 text-xs font-black text-amber-950">
              {i + 1}
            </span>
            <div>
              <p className="text-[13px] font-extrabold text-amber-200">{r.t}</p>
              <p className="mt-0.5 text-[12px] leading-snug text-white/75">{r.d}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  )
})

ModalRules.displayName = 'ModalRules'
